/** JWT lifetime (seconds) for Intercom Messenger Security; server signing must use this value. */
export const INTERCOM_USER_JWT_TTL_SECONDS = 900;

/** React Query staleTime for intercom-data — keep below JWT lifetime so tokens are refreshed before exp. */
export const INTERCOM_DATA_STALE_TIME_MS = 12 * 60 * 1000;
